<template></template>

<script>
import { loading } from "../mixins/LoadingMixin";
import { EventBus } from "../mixins/EventBus";
import { ConfirmActionMixin } from "../mixins/ConfirmActionMixin";

export default {
  mixins: [loading, EventBus, ConfirmActionMixin],

  props: {
    action: {
      default: "show",
    },
    texts: {
      default: () => {},
    },
  },

  data() {
    return {
      name: "modal-" + this._uid,
    };
  },

  computed: {
    now() {
      return moment();
    },
  },

  methods: {
    show() {
      this.$modal.show(this.name);
    },

    hide() {
      this.$modal.hide(this.name);
    },
  },
};
</script>
<style>
.timetable-wrapper .v--modal-overlay {
  z-index: 100000 !important;
  overflow: auto;
}

/*
 * The shared confirm dialog (`confirmAction`) is a single <v-dialog/> in the page
 * layout, so it sits OUTSIDE .timetable-wrapper and never got the boost above --
 * it stayed on the library's default 999 and opened *behind* the very modal that
 * asked for the confirmation. It has to outrank every timetable modal, since it
 * is only ever opened on top of one.
 */
.v--modal-overlay[data-modal="dialog"] {
  z-index: 100001 !important;
}

.add-event-modal.v--modal-overlay .v--modal-box {
  overflow: visible;
}

.show-more-options.v--modal-overlay {
  position: initial;
}

.show-more-options.v--modal-overlay .v--modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1090 !important;
  padding: 30px;
  overflow: auto !important;
}
</style>
